import { $authHost } from ".";
import { GetPurchaseHistoryResponse } from "@/@types/purchaseHistory.types";

export async function getPurchaseHistory() {
  const response = await $authHost.request<GetPurchaseHistoryResponse>({
    url: "/purchase_history",
  });
  return response;
}
